import { useEffect, useState } from "react";
import api from "../../../lib/api";
import { Plus, Save } from "lucide-react";
import { Modal, Input } from "./ServicesManager";
import BilingualField from "../BilingualField";

export default function TestimonialsManager() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/testimonials").then(({ data }) => setItems(data));
  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const save = async () => {
    if (editing.id) await api.put(`/testimonials/${editing.id}`, editing);
    else await api.post("/testimonials", editing);
    setEditing(null);
    load();
  };
  const remove = async (id) => {
    if (!window.confirm("Supprimer ?")) return;
    await api.delete(`/testimonials/${id}`);
    load();
  };
  const trFr = (v) => (typeof v === "string" ? v : v?.fr || v?.en || "");

  return (
    <div data-testid="testimonials-manager">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="font-serif text-4xl">Témoignages</h1>
          <p className="text-[#4A3F35] mt-2">Avis clients (FR + EN).</p>
        </div>
        <button onClick={() => setEditing({ name: "", role: { fr: "", en: "" }, content: { fr: "", en: "" }, rating: 5 })} className="btn-primary">
          <Plus size={16} /> Ajouter
        </button>
      </div>

      <div className="grid md:grid-cols-2 gap-5">
        {items.map((t) => (
          <div key={t.id} className="bg-[#FDFBF7] rounded-2xl p-5 border border-[#2D2A26]/10">
            <div className="text-[#C87A5E] mb-2">{"★".repeat(t.rating || 5)}</div>
            <p className="font-serif italic">&ldquo;{trFr(t.content)}&rdquo;</p>
            <div className="mt-3 text-sm"><span className="font-medium">{t.name}</span> · <span className="text-[#4A3F35]/60">{trFr(t.role)}</span></div>
            <div className="flex gap-3 mt-3 text-sm">
              <button onClick={() => setEditing(t)} className="link-underline text-[#C87A5E]">Modifier</button>
              <button onClick={() => remove(t.id)} className="link-underline text-red-700">Supprimer</button>
            </div>
          </div>
        ))}
      </div>

      {editing && (
        <Modal onClose={() => setEditing(null)} title={editing.id ? "Modifier" : "Nouveau témoignage"}>
          <div className="space-y-4">
            <Input label="name" value={editing.name} onChange={(v) => setEditing({ ...editing, name: v })} />
            <BilingualField label="role" value={editing.role} onChange={(v) => setEditing({ ...editing, role: v })} testid="t-role" />
            <BilingualField label="content" value={editing.content} onChange={(v) => setEditing({ ...editing, content: v })} type="textarea" rows={4} testid="t-content" />
            <Input label="rating" type="number" value={editing.rating} onChange={(v) => setEditing({ ...editing, rating: Number(v) })} />
            <button onClick={save} className="btn-primary w-full justify-center" data-testid="testimonial-save"><Save size={16} /> Enregistrer</button>
          </div>
        </Modal>
      )}
    </div>
  );
}
